import Vue from 'vue'
import EkDialog from './EkDialog.vue'

export function EkPreviewDialog(url) {
    const container = document.createElement('div')
    document.body.appendChild(container)
    const ComponentConstructor = Vue.extend({
        components: {
            EkDialog
        },
        render(h) {
            return h('EkDialog', {
                props: {
                    url: url
                },
                on: {
                    close: () => {
                        console.log('EkPreviewDialog closed')
                        vm.$destroy()
                        Vue.nextTick(() => {
                            const el = document.getElementById('preview-dialog-box')
                            if (el) {
                                document.body.removeChild(el)
                            }
                        })
                    }
                }
            })
        }
    })
    const vm = new ComponentConstructor().$mount(container)
}
